<template>
  <div>
    <!--    Cabecera con parte del vídeo-->
    <section class="bg-primary py-5 bg-trama">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-12 text-white my-5">
            <h1>Esto es… nuestra Plaza Mayor</h1>
          </div>

          <div class="col-12">
            <p class="subtitular text-white">
              Si hay un lugar de Madrid que disfrutamos todos, ése es la Plaza Mayor. Allí se celebran conciertos, se
              establece el mercadillo de Navidad más grande de la ciudad, se dan cita familias o parejas, en sus
              inmediaciones se congregan algunos de los mejores restaurantes de la capital.
            </p>
            <p class="subtitular text-white">
              En la Sierra Norte de Madrid también tenemos
              <strong>lugares que puede disfrutar todo el mundo,</strong> independientemente de su edad, sus aficiones o
              sus características físicas.
            </p>
          </div>
          <!--          <div class="col-12 mt-4">-->
          <!--            <img src="/img/icons/aventureros.svg" alt="Planes especiales para aventureros" class="mr-3" /><span-->
          <!--              class="text-black small"-->
          <!--              >Planes especiales para aventureros</span-->
          <!--            >-->
          <!--            <div class="w100 my-5"></div>-->
          <!--          </div>-->
        </div>
      </div>
    </section>

    <!--      Fin de cabecera-->
    <!--      Sección con scroll horizontal-->

    <div id="scroll-wrapper" class="container-fluid scroll-wrapper bg-light">
      <div id="scrollContainer" class="scroll-sections">
        <div id="fondo-puntos" style="overflow: hidden;width:50px;position:absolute;height: 100vh;left:70vh">
          <img src="/img/caminos/camino-1.svg" alt="" style="position: absolute;top:30%;z-index:2" />
        </div>

        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <h2 class="mb-4">Diversión para todos los públicos</h2>
            <p class="subtitular z-index-up">
              Muchos de los espacios naturales, los talleres y las actividades de la Sierra Norte de Madrid están
              adaptados para que cualquier persona pueda encontrar
              <strong>espacios de entretenimiento y diversión en los que disfrutar sin barreras.</strong> ¡Ven a
              conocerlos!
            </p>
            <a href="https://www.sierranortemadrid.org/restaurantes/" class="btn btn-primary mr-3 mt-2" target="_blank">
              ¿Dónde comer?
            </a>
            <a href="https://www.sierranortemadrid.org/alojamiento/" class="btn btn-primary mt-2" target="_blank">
              ¿Dónde alojarse?
            </a>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta9/reduena.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Ruta adaptada de Redueña</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      La
                      <a
                        href="https://www.sierranortemadrid.org/ruta-adaptada-reduena/"
                        target="_blank"
                        alt="Más información sobre la actividad"
                        >Senda para Todos</a
                      >
                      es un <strong>recorrido sin apenas desnivel con un trazo firme,</strong> que permite el acceso a
                      personas con movilidad reducida o en silla de ruedas.
                    </span>
                  </li>
                  <li>
                    <span>
                      <strong>Los contenidos de los paneles están adaptados para las personas invidentes,</strong
                      >strong> con textos en braille y volúmenes en relieve para que puedan conocer la riqueza ambiental
                      de la dehesa boyal de Redueña.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h30m" />
                  <icon-todas-estaciones />
                  <icon-familias />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Ruta adaptada de Redueña</h3>
                <p>
                  Si te gusta sentir la naturaleza y disfrutar del sonido del silencio, ¡este plan es para ti!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal1 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h30m" />
                  <icon-todas-estaciones />
                  <icon-familias />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Inicio "2" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta9/apicultura.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>

              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Apicultor por un día</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      A través de una charla informativa
                      <strong
                        >conocerás en profundidad el trabajo de los
                        <a
                          href="https://www.sierranortemadrid.org/planes/apicultor-por-un-dia-braojos/"
                          target="_blank"
                          alt="Más información sobre la actividad"
                          >apicultores.</a
                        ></strong
                      >
                    </span>
                  </li>
                  <li>
                    <span>
                      También podrás visitar el colmenar, donde podrás observar la vida de las abejas de cerca.
                      <strong>¡Y te podrás llevar un tarrito de miel, recogido por ti!</strong>
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="4h" />
                  <icon-primavera />
                  <icon-otono />
                  <icon-foodies />
                  <icon-familias />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Apicultor por un día</h3>
                <p>Disfruta de una jornada en la que aprenderás todo lo relacionado con el mundo de las abejas.</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal2 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="4h" />
                  <icon-primavera />
                  <icon-otono />
                  <icon-foodies />
                  <icon-familias />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta9/sin-barreras.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Lozoya sin barreras</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      Rutas para todos los públicos por las inmediaciones del Parque Nacional de la Sierra del
                      Guadarrama.
                    </span>
                  </li>
                  <li>
                    <span>
                      Esta actividad
                      <strong
                        >incluye el uso de
                        <a
                          href="https://www.sierranortemadrid.org/lozoya-montanas-sin-barreras/"
                          target="_blank"
                          alt="Más información sobre la actividad"
                        ></a>
                        sillas todo terreno joëlettes,</strong
                      >
                      lo que permite el acceso a las mismas de personas con diversidad funcional motora o dificultad en
                      el andar.
                    </span>
                  </li>
                  <li>
                    <span>
                      La actividad <strong>puede realizarse prácticamente los 365 días del año,</strong> aunque nosotros
                      recomendamos hacerla en primavera y verano.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="4h" />
                  <icon-aventureros />
                  <icon-todas-estaciones />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Lozoya sin barreras</h3>
                <p>
                  Rutas para todos los públicos por las inmediaciones del Parque Nacional de la Sierra del Guadarrama.
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal3 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="4h" />
                  <icon-aventureros />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "2" slider ******************-->
        <!--          Inicio "3" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta9/gong.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Baño de Gong</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¿Alguna vez has oído hablar de los
                      <a
                        href="https://www.sierranortemadrid.org/planes/bano-de-gong"
                        target="_blank"
                        alt="Más información sobre la actividad"
                        >Baños de Gong?</a
                      >
                      Se trata de una experiencia en la que
                      <strong>el cuerpo llega a un estado de relajación que alivia las tensiones,</strong> y en el que
                      la respiración se vuelve profunda y consciente.
                    </span>
                  </li>
                  <li>
                    <span>
                      Los efectos terapéuticos del Gong no se asocian solamente al plano físico:
                      <strong>trae grandes beneficios también para la mente y el espíritu.</strong>
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h15m" />
                  <icon-parejas />
                  <icon-todas-estaciones />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Baño de Gong</h3>

                <p>Disfruta de una experiencia relajante en un entorno único, para cuidar la mente y el cuerpo.</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal4 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h15m" />
                  <icon-parejas />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "3" slider ******************-->
      </div>
    </div>
    <!--    Fin sección scroll horizontal-->
    <!--    Inicio modals-->

    <!--   Inicio Modal 1-->
    <b-modal id="modal1" centered scrollable size="lg" hide-footer title="Ruta adaptada de Redueña.">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                La
                <a
                  href="https://www.sierranortemadrid.org/ruta-adaptada-reduena/"
                  target="_blank"
                  alt="Más información sobre la actividad"
                  >Senda para Todos</a
                >
                es un <strong>recorrido sin apenas desnivel con un trazo firme,</strong> que permite el acceso a
                personas con movilidad reducida o en silla de ruedas.
              </span>
            </li>
            <li>
              <span>
                <strong>Los contenidos de los paneles están adaptados para las personas invidentes,</strong>strong> con
                textos en braille y volúmenes en relieve para que puedan conocer la riqueza ambiental de la dehesa boyal
                de Redueña.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 1-->
    <!--   Inicio Modal 2-->
    <b-modal id="modal2" centered scrollable size="lg" hide-footer title="Apicultor por un día">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                A través de una charla informativa
                <strong
                  >conocerás en profundidad el trabajo de los
                  <a
                    href="https://www.sierranortemadrid.org/planes/apicultor-por-un-dia-braojos/"
                    target="_blank"
                    alt="Más información sobre la actividad"
                    >apicultores.</a
                  ></strong
                >
              </span>
            </li>
            <li>
              <span>
                También podrás visitar el colmenar, donde podrás observar la vida de las abejas de cerca.
                <strong>¡Y te podrás llevar un tarrito de miel, recogido por ti!</strong>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 2-->
    <!--   Inicio Modal 3-->
    <b-modal id="modal3" centered scrollable size="lg" hide-footer title="Lozoya sin barreras">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                Esta actividad
                <strong
                  >incluye el uso de
                  <a
                    href="https://www.sierranortemadrid.org/lozoya-montanas-sin-barreras/"
                    target="_blank"
                    alt="Más información sobre la actividad"
                  ></a>
                  sillas todo terreno joëlettes,</strong
                >
                lo que permite el acceso a las mismas de personas con diversidad funcional motora o dificultad en el
                andar.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 3-->
    <!--   Inicio Modal 4-->
    <b-modal id="modal4" centered scrollable size="lg" hide-footer title="Baño de Gong">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                ¿Alguna vez has oído hablar de los
                <a
                  href="https://www.sierranortemadrid.org/planes/bano-de-gong"
                  target="_blank"
                  alt="Más información sobre la actividad"
                  >Baños de Gong?</a
                >
                Se trata de una experiencia en la que
                <strong>el cuerpo llega a un estado de relajación que alivia las tensiones,</strong> y en el que la
                respiración se vuelve profunda y consciente.
              </span>
            </li>
            <li>
              <span>
                Los efectos terapéuticos del Gong no se asocian solamente al plano físico:
                <strong>trae grandes beneficios también para la mente y el espíritu.</strong>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 4-->
    <!--    Fin de modal-->
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  components: {
    IconTime: () => import('../../components/iconos/IconTime'),
    IconFamilias: () => import('../../components/iconos/IconFamilias'),
    IconFoodies: () => import('../../components/iconos/IconFoodies'),
    IconOtono: () => import('../../components/iconos/IconOtono'),
    IconParejas: () => import('../../components/iconos/IconParejas'),
    IconPrimavera: () => import('../../components/iconos/IconPrimavera'),
    IconTodasEstaciones: () => import('../../components/iconos/IconTodasEstaciones'),
    IconAventureros: () => import('../../components/iconos/IconAventureros')
  },
  mounted() {
    if (window.innerWidth > 1000) {
      const horizontalSlide = new TimelineMax().to('#scrollContainer', 1, { x: '-30%' })
      const scene = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '300%'
        })
        .setPin('#scroll-wrapper')
        .setTween(horizontalSlide)
      const scene2 = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '300%'
        })
        .setTween('#fondo-puntos', {
          width: '40%'
        })

      this.$scrollmagic.addScene(scene)
      this.$scrollmagic.addScene(scene2)
    }
  }
}
</script>
